import { connect } from "react-redux";
import { ProtocolTask as Component } from "./ProtocolTask";

import {
  saveTaskNote,
  setModal,
  showModal,
  spectrophotometerToggleInfoModal,
  setupComplete,
} from "@learningblocks/protocol-redux/lib/Actions";

function mapStateToProps() {
  return {
    pIndex: 1,
    tIndex: 1,
    level: 1,
    page: 1,
    task: "Task",
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setupComplete: (data) => {
      dispatch(setupComplete(data));
    },
    spectrophotometerToggleInfoModal: (data) => {
      dispatch(spectrophotometerToggleInfoModal(data));
    },
    saveTaskNote: (data) => {
      dispatch(saveTaskNote(data));
    },
    setModal: (data) => {
      dispatch(setModal(data));
    },
    showModal: (data) => {
      dispatch(showModal(data));
    },
  };
}

export const ProtocolTask = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
